import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-center mt-8\"><div class=\"flex items-center\"><svg class=\"w-8 h-8 ml-2 text-blue-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z\"></path></svg><span class=\"mx-2 text-2xl font-semibold text-white\">VueBoard</span></div></div>", 1)
const _hoisted_3 = { class: "mt-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "pl-4 text-xs font-semibold mb-4 text-gray-400" }, "GENERAL", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Dashboard", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "pl-4 my-2 text-xs font-semibold mb-4 text-gray-400" }, " Examples ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 3C3.89543 3 3 3.89543 3 5V7C3 8.10457 3.89543 9 5 9H7C8.10457 9 9 8.10457 9 7V5C9 3.89543 8.10457 3 7 3H5Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 11C3.89543 11 3 11.8954 3 13V15C3 16.1046 3.89543 17 5 17H7C8.10457 17 9 16.1046 9 15V13C9 11.8954 8.10457 11 7 11H5Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 5C11 3.89543 11.8954 3 13 3H15C16.1046 3 17 3.89543 17 5V7C17 8.10457 16.1046 9 15 9H13C11.8954 9 11 8.10457 11 7V5Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 13C11 11.8954 11.8954 11 13 11H15C16.1046 11 17 11.8954 17 13V15C17 16.1046 16.1046 17 15 17H13C11.8954 17 11 16.1046 11 15V13Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "UI Elements", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 3C6.44772 3 6 3.44772 6 4C6 4.55228 6.44772 5 7 5H13C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3H7Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 7C4 6.44772 4.44772 6 5 6H15C15.5523 6 16 6.44772 16 7C16 7.55228 15.5523 8 15 8H5C4.44772 8 4 7.55228 4 7Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2 11C2 9.89543 2.89543 9 4 9H16C17.1046 9 18 9.89543 18 11V15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15V11Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Tables", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Forms", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Cards", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Modal", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Charts", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Blank", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "pl-4 text-xs my-2 font-semibold mb-4 text-gray-400" }, "About", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 fill-current",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12.026 2C7.13295 1.99937 2.96183 5.54799 2.17842 10.3779C1.395 15.2079 4.23061 19.893 8.87302 21.439C9.37302 21.529 9.55202 21.222 9.55202 20.958C9.55202 20.721 9.54402 20.093 9.54102 19.258C6.76602 19.858 6.18002 17.92 6.18002 17.92C5.99733 17.317 5.60459 16.7993 5.07302 16.461C4.17302 15.842 5.14202 15.856 5.14202 15.856C5.78269 15.9438 6.34657 16.3235 6.66902 16.884C6.94195 17.3803 7.40177 17.747 7.94632 17.9026C8.49087 18.0583 9.07503 17.99 9.56902 17.713C9.61544 17.207 9.84055 16.7341 10.204 16.379C7.99002 16.128 5.66202 15.272 5.66202 11.449C5.64973 10.4602 6.01691 9.5043 6.68802 8.778C6.38437 7.91731 6.42013 6.97325 6.78802 6.138C6.78802 6.138 7.62502 5.869 9.53002 7.159C11.1639 6.71101 12.8882 6.71101 14.522 7.159C16.428 5.868 17.264 6.138 17.264 6.138C17.6336 6.97286 17.6694 7.91757 17.364 8.778C18.0376 9.50423 18.4045 10.4626 18.388 11.453C18.388 15.286 16.058 16.128 13.836 16.375C14.3153 16.8651 14.5612 17.5373 14.511 18.221C14.511 19.555 14.499 20.631 14.499 20.958C14.499 21.225 14.677 21.535 15.186 21.437C19.8265 19.8884 22.6591 15.203 21.874 10.3743C21.089 5.54565 16.9181 1.99888 12.026 2Z" })
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "Github", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

import { ref } from "vue";
import { useSidebar } from "../hooks/useSidebar";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isOpen } = useSidebar();
const activeClass = ref(
  "bg-gray-600 bg-opacity-25 text-gray-100 border-gray-100"
);
const inactiveClass = ref(
  "border-gray-900 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100"
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(isOpen) ? 'block' : 'hidden', "fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden"]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(isOpen) ? 'translate-x-0 ease-out' : '-translate-x-full ease-in', "fixed inset-y-0 left-0 z-30 w-64 overflow-y-auto transition duration-300 transform bg-gray-900 lg:translate-x-0 lg:static lg:inset-0"])
    }, [
      _hoisted_2,
      _createElementVNode("nav", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Dashboard' ? activeClass.value : inactiveClass.value]]),
          to: "/dashboard"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }, 8, ["class"]),
        _hoisted_7,
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'UIElements' ? activeClass.value : inactiveClass.value]]),
          to: "/ui-elements"
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _hoisted_9
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Tables' ? activeClass.value : inactiveClass.value]]),
          to: "/tables"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Forms' ? activeClass.value : inactiveClass.value]]),
          to: "/forms"
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _hoisted_13
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Cards' ? activeClass.value : inactiveClass.value]]),
          to: "/cards"
        }, {
          default: _withCtx(() => [
            _hoisted_14,
            _hoisted_15
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Modal' ? activeClass.value : inactiveClass.value]]),
          to: "/modal"
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            _hoisted_17
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Chart' ? activeClass.value : inactiveClass.value]]),
          to: "/charts"
        }, {
          default: _withCtx(() => [
            _hoisted_18,
            _hoisted_19
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Blank' ? activeClass.value : inactiveClass.value]]),
          to: "/blank"
        }, {
          default: _withCtx(() => [
            _hoisted_20,
            _hoisted_21
          ]),
          _: 1
        }, 8, ["class"]),
        _hoisted_22,
        _createElementVNode("a", {
          target: "_blank",
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Blank' ? activeClass.value : inactiveClass.value]]),
          href: "https://github.com/tal7aouy"
        }, _hoisted_25, 2)
      ])
    ], 2)
  ]))
}
}

})